import { apiClient } from "./client";
import type { PostEventsResponse, WebAnalyticsEvent } from "~/types/analytics";

/**
 * Send first-party web analytics events to our own backend (POST /api/pubsub_events/web →
 * Pub/Sub `web_events` → BigQuery). `session: "none"` because this is anonymous ingestion: it must
 * work for logged-out visitors and never block on the auth session bootstrap.
 */
export async function postWebAnalyticsEvents(events: WebAnalyticsEvent[]): Promise<PostEventsResponse> {
  return apiClient.makeAuthenticatedRequest<PostEventsResponse>("/pubsub_events/web", {
    method: "POST",
    session: "none",
    params: { events },
  });
}
